module.exports = __webpack_public_path__ + "static/img/29.351723bb.png";